import React from 'react';
import { useDrag } from 'react-dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Tooltip } from '@mui/material';
import { fontSize, palette } from '../../..';
import FunctionsIcon from '@mui/icons-material/Functions';
import { rowLevelCalculationFunctions, visuallyAggregatedFunctionNames } from '../constants';

const DraggableCalculationListItem = ({
  name,
  type,
  fieldData,
  colsOnly,
  definition,
  string,
  flowName,
}: any) => {
  const [collect, drag] = useDrag({
    type: 'calculationPicked',
    item: { flowName, name, type, fieldData, bIndex: 99 },
    collect: (monitor) => ({
      opacity: monitor.isDragging() ? 0.4 : 1,
      isDragging: monitor.isDragging() ? true : false,
    }),
  });

  const functionName = flowName ?? name;
  const isVisualLevel = visuallyAggregatedFunctionNames.includes(functionName);
  const isRowLevel = rowLevelCalculationFunctions.includes(functionName);

  // Determine availability text
  const getAvailabilityText = () => {
    if (isVisualLevel && isRowLevel) {
      return 'Available for Visual Level Aggregation & Row Level Calculation';
    } else if (isVisualLevel) {
      return 'Available for Visual Level Aggregation';
    } else if (isRowLevel) {
      return 'Available for Row Level Calculation';
    }
    return '';
  };

  const availabilityText = getAvailabilityText();

  const tooltipContent = (
    <div>
      <div>{definition}</div>
      {availabilityText && <div style={{ marginTop: '8px' }}>{availabilityText}</div>}
    </div>
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="right"
      slotProps={{
        tooltip: {
          className: 'tooltip-font',
        },
      }}
    >
      <div
        ref={drag}
        className={'styleForColumnsOnly calcItemHover'}
        data-testid={`${name}_calculation`}
      >
        <DragIndicatorIcon
          style={{ marginLeft: '-2px', color: palette.primary.contrastText }}
          fontSize="small"
        />
        <span
          style={{
            color: palette.primary.contrastText,
            fontSize: fontSize.medium,
            textTransform: 'capitalize',
            fontWeight: '400',
          }}
          className="boxText"
        >
          {name === 'IfElse' ? 'If Else' : String(name[0]).toUpperCase() + name.slice(1)}
        </span>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: 'auto',
            color: palette.primary.contrastText,
          }}
        >
          <FunctionsIcon
            fontSize="small"
            sx={{
              color: palette.primary.contrastText,
              opacity: isVisualLevel ? 1 : 0.15,
            }}
          />
          <MenuIcon
            fontSize="small"
            sx={{
              color: palette.primary.contrastText,
              opacity: isRowLevel ? 1 : 0.15,
            }}
          />
        </Box>
      </div>
    </Tooltip>
  );
};

export default DraggableCalculationListItem;
